import { render, staticRenderFns } from "./MatchBucket.vue?vue&type=template&id=50b5e67f"
import script from "./MatchBucket.vue?vue&type=script&lang=js"
export * from "./MatchBucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports